import decamelizeKeys from 'decamelize-keys';
import gql from 'graphql-tag';

import apolloClient from './apolloClient';
import { BackendAnalyticsTrackInput } from './types';

export const TRACK_EVENT = gql`
  mutation analytics_track($input: AnalyticsTrackInput!) {
    analytics_track(input: $input) {
      uuid: id
    }
  }
`;

export const backendAnalyticsTrack = async (input: BackendAnalyticsTrackInput) => {
  await apolloClient
    .mutate({
      mutation: TRACK_EVENT,
      variables: {
        input: decamelizeKeys(input),
      },
    })
    .catch(console.error);
};
